export const SOCIAL_LINKS = {
    github: {
        url: "https://github.com/w0nght",
        label: "GitHub",
        icon: "FaGithub",
    },
    linkedin: {
        url: "https://www.linkedin.com/in/joey-wong-4-work/",
        label: "LinkedIn",
        icon: "FaLinkedin",
    },
    email: {
        url: "mailto:joeywong4work@gmail.com",
        label: "Email",
        icon: "FaEnvelope",
    },
};
